import { render, staticRenderFns } from "./edit-partner.vue?vue&type=template&id=f93932b0&scoped=true&"
import script from "./edit-partner.vue?vue&type=script&lang=js&"
export * from "./edit-partner.vue?vue&type=script&lang=js&"
import style0 from "./edit-partner.vue?vue&type=style&index=0&id=f93932b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93932b0",
  null
  
)

export default component.exports